import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import { getAdminProgramCodes } from '@api/adminLookups';
import {
  adminCreateNewProgramCode,
  adminEditProgramCode,
  getAdminProgramCodeDetails,
} from '@api/adminProgramCodes';
import {
  IAdminProgramCode,
  IAdminProgramCodeCreateNewPayload,
  IAdminProgramCodeDetails,
  IAdminProgramCodeEditPayload,
} from '@interfaces/adminProgramCodes';
import { IIdentity } from '@interfaces/common';

export const handleGetAdminProgramCodes = createAsyncThunk<
  AxiosResponse<IAdminProgramCode[]>,
  void
>('getAdminProgramCodes', getAdminProgramCodes);

export const handleGetAdminProgramCodeDetails = createAsyncThunk<
  AxiosResponse<IAdminProgramCodeDetails>,
  number
>('getAdminProgramCodeDetails', getAdminProgramCodeDetails);

export const handleAdminCreateNewProgramCode = createAsyncThunk<
  AxiosResponse<IIdentity>,
  IAdminProgramCodeCreateNewPayload
>('adminCreateNewProgramCode', adminCreateNewProgramCode);

export const handleAdminEditProgramCode = createAsyncThunk<
  AxiosResponse<Record<string, unknown>>,
  IAdminProgramCodeEditPayload
>('adminEditProgramCode', adminEditProgramCode);
